import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/hooks/useAuth";
import Layout from "@/components/Layout";
import Index from "./pages/Index";
import Services from "./pages/Services";
import ServiceLanding from "./pages/ServiceLanding";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Coaching from "./pages/Coaching";
import Blog from "./pages/Blog";
import BlogArticle from "./pages/BlogArticle";
import BlogMap from "./pages/BlogMap";
import NotFound from "./pages/NotFound";
import ElevateMoment from "./pages/ElevateMoment";
import Sitemap from "./pages/Sitemap";
import BookAppointment from "./pages/BookAppointment";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import PrivateRoute from "./components/PrivateRoute";
import SeoOverrides from "./components/SeoOverrides";



const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <AuthProvider>
            <SeoOverrides />
            <Layout>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/:slug" element={<ServiceLanding />} />
                <Route path="/about" element={<About />} />
                <Route path="/coaching" element={<Coaching />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/map" element={<BlogMap />}/>
                <Route path="/blog/:slug" element={<BlogArticle />} />
                <Route path="/elevate-moment" element={<ElevateMoment />} />
                <Route path="/sitemap" element={<Sitemap />} />
                <Route path="/book" element={<BookAppointment />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
                
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Layout>
          </AuthProvider>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
